export default __webpack_public_path__ + "static/media/scratch-share.2e2a113a.png";